import gql from 'graphql-tag'

// Query para obtener la URL firmada de lectura
export const generateReadSignedURL = (fileName) => {
    return {
        query: gql`
            query GenerateReadSignedURL($fileName: String!) {
                generateReadSignedURL(fileName: $fileName)
            }
        `,
        variables: {
            fileName,
        },
    }
}

// Mutation para obtener la URL firmada de subida
export const generateUploadSignedURL = (fileName, fileType) => {
    return {
        mutation: gql`
            mutation GenerateUploadSignedURL($fileName: String!, $fileType: String!) {
                generateUploadSignedURL(fileName: $fileName, fileType: $fileType)
            }
        `,
        variables: {
            fileName,
            fileType,
        },
    }
}
